<template>
<div class="cnt-slider">
    <div class="lst-slider">
        <slick class="slider-row slick" ref="slick_exchanges" :options="slickOptions">
            <li v-for="item in summarys" :key="item.currency_id">
                <div class="box-news">
                    <div class="box-heading">
                        <div class="exchange-title">{{ $t('summary.summary_exchange') }}</div>
                        <div class="unit-date">{{ utils.getCurrencyName(item.currency_id) }}</div>
                    </div>
                    <div class="summary-exchange">
                        <div class="cnt-item">
                            <div class="ttl">{{ $t('summary.label.initial_carry_cash') }}</div>
                            <div class="num">{{ utils.formatPrice(item.exchanges.initial_carry_cash, item.currency_id) }}</div>
                        </div>
                        <div class="cnt-item">
                            <div class="ttl">{{ $t('summary.label.exchange_in') }}</div>
                            <div class="num">{{ utils.formatPrice(item.exchanges.exchange_in, item.currency_id) }}</div>
                        </div>
                        <div class="cnt-item">
                            <div class="ttl">{{ $t('summary.label.exchange_out') }}</div>
                            <div class="num">{{ utils.formatPrice(item.exchanges.exchange_out, item.currency_id) }}</div>
                        </div>
                        <div class="cnt-item deduction">
                            <div class="ttl ttl-total">{{ $t('summary.label.deduction') }}</div>
                            <div class="num">{{ utils.formatPrice(item.exchanges.deduction, item.currency_id) }}</div>
                        </div>
                        <div class="cnt-item">
                            <div class="ttl">{{ $t('summary.label.carry_cash_balance') }}</div>
                            <div class="num">{{ utils.formatPrice((item.carry_cashs.expenditure - 0) + (item.carry_cashs.income - 0), item.currency_id) }}</div>
                        </div>
                        <div class="cnt-item">
                            <div class="ttl">{{ $t('summary.label.local_income_balance') }}</div>
                            <div class="num">{{ utils.formatPrice(item.local_incomes.total != null ? item.local_incomes.total : 0, item.currency_id) }}</div>
                        </div>
                        <div class="cnt-item total">
                            <div class="ttl ttl-total">{{ $t('summary.label.remaining_balance') }}</div>
                            <div class="num">{{ utils.formatPrice(item.total) }}</div>
                        </div>
                    </div>
                </div>
            </li>
        </slick>
    </div>
</div>
</template>
<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Utils from "@/helpers/utils";

export default {
    name: "SpExchangeSummary",
    props: {
        summarys: {},
        slickOptions: {},
    },
    components: {
        Slick,
    },
    data() {
        return {
            utils: Utils,
        };
    },
    methods: {
    }
};
</script>


// WEBPACK FOOTER //
// src/views/components/common/Summary/ExchangeSummary.vue